import createIcon from '../../createIcon';

/**
 * @component @name Dns
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTNINEMzLjQ1IDEzIDMgMTMuNDUgMyAxNFYyMEMzIDIwLjU1IDMuNDUgMjEgNCAyMUgyMEMyMC41NSAyMSAyMSAyMC41NSAyMSAyMFYxNEMyMSAxMy40NSAyMC41NSAxMyAyMCAxM1pNNyAxOUM1LjkgMTkgNSAxOC4xIDUgMTdDNSAxNS45IDUuOSAxNSA3IDE1QzguMSAxNSA5IDE1LjkgOSAxN0M5IDE4LjEgOC4xIDE5IDcgMTlaTTIwIDNINEMzLjQ1IDMgMyAzLjQ1IDMgNFYxMEMzIDEwLjU1IDMuNDUgMTEgNCAxMUgyMEMyMC41NSAxMSAyMSAxMC41NSAyMSAxMFY0QzIxIDMuNDUgMjAuNTUgMyAyMCAzWk03IDlDNS45IDkgNSA4LjEgNSA3QzUgNS45IDUuOSA1IDcgNUM4LjEgNSA5IDUuOSA5IDdDOSA4LjEgOC4xIDkgNyA5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Dns = createIcon('Dns', [
  [
    'path',
    {
      d: 'M20 13H4C3.45 13 3 13.45 3 14V20C3 20.55 3.45 21 4 21H20C20.55 21 21 20.55 21 20V14C21 13.45 20.55 13 20 13ZM7 19C5.9 19 5 18.1 5 17C5 15.9 5.9 15 7 15C8.1 15 9 15.9 9 17C9 18.1 8.1 19 7 19ZM20 3H4C3.45 3 3 3.45 3 4V10C3 10.55 3.45 11 4 11H20C20.55 11 21 10.55 21 10V4C21 3.45 20.55 3 20 3ZM7 9C5.9 9 5 8.1 5 7C5 5.9 5.9 5 7 5C8.1 5 9 5.9 9 7C9 8.1 8.1 9 7 9Z',
      key: 'vu2j92',
    },
  ],
]);

export default Dns;
